'use strict';

const { ACTION_TYPES } = require('./actions');

const defaultState = {
    messagesSent: [],
    bulkHoldRequestItems: null, // dig
    holdRequestedFromConfirmationModal: false, // dig
    taggedProjectName: null,
    onApprovalRequestSent: false,
    isError: false,
    isSending: false,
    submitDisabled: false,
    hasInvalidCharacterError: false,
    currentStep: '',
    backLinkTargets: {},
    modalContentData: null,
};

module.exports = (state = defaultState, action) => {
    switch (action.type) {
        case ACTION_TYPES.resetContactData:
            /* reset everything except bulkHoldRequestItems, messagesSent and taggedProjectName,
            because these affect what is displayed on the confirmation modal */
            return {
                ...defaultState,
                bulkHoldRequestItems: state.bulkHoldRequestItems,
                messagesSent: state.messagesSent,
                taggedProjectName: state.taggedProjectName,
                onApprovalRequestSent: state.onApprovalRequestSent,
            };
        case ACTION_TYPES.messageSuccess: {
            const { messageType } = action;
            return { ...state, messagesSent: [messageType, ...state.messagesSent] };
        }
        case ACTION_TYPES.setTaggedProjectName:
            return { ...state, taggedProjectName: action.taggedProjectName };
        case ACTION_TYPES.onApprovalRequestSent:
            return { ...state, onApprovalRequestSent: true };
        case ACTION_TYPES.setServiceError:
            return {
                ...state,
                isError: true,
                submitDisabled: false,
                isSending: false,
                hasInvalidCharacterError: action.hasInvalidCharacterError,
            };
        case ACTION_TYPES.gotoModalStep: {
            const updatedBackLinkTargets = Object.assign(
                {},
                state.backLinkTargets,
                action.isBackLink ? {} : { [action.currentStep]: state.currentStep }
            );
            return {
                ...state,
                currentStep: action.currentStep,
                backLinkTargets: updatedBackLinkTargets,
                modalContentData: action.modalContentData,
            };
        }
        case ACTION_TYPES.messageSuccess:
            return { ...state, isSending: false };
        default:
            return state;
    }
};
